import * as React from 'react'
import { usePost } from '~/contexts/PostContext'
import { notBlank } from '~/utils/helpers'

import { cta_link } from "~/styles/blog/blog.module.scss"
import * as styles from "~/styles/blog/blog-store.module.scss"

const BlogStore = ({ blockId, index }) => {
  const { post } = usePost()
  const block = post.data.blocks.find(x => x.id === blockId)
  const { settings } = block

  const address = `${settings.address1},${notBlank(settings.address2) ? ` ${settings.address2},` : ''}`
  const gmaps_address = encodeURIComponent(`${address} ${settings.city}, ${settings.state} ${settings.zip}`)

  return (

    <div className={styles.store} block={block.id}>
      <div className={styles.store_title} dangerouslySetInnerHTML={{ __html: settings.title }} />

      <div className={styles.store_info}>
        <div className={styles.address}>
          <p>
            {notBlank(settings.address1) && (
              <>
                {settings.address1}
                <br/>
              </>
            )}
            {notBlank(settings.address2) && (
              <>
                {settings.address2}
                <br/>
              </>
            )}
            {notBlank(settings.city) ? `${settings.city}, ${settings.state} ${settings.zip}` : ''}
          </p>
          {notBlank(settings.phone) && (
            <a 
              href={`tel:${settings.phone.replace('.', '').replace('-', '')}`} 
              className={styles.phone}>
              {settings.phone}
            </a>
          )}
        </div>
      </div>
      <div className={styles.hours} dangerouslySetInnerHTML={{ __html: settings.hours }} />
      <div className={styles.features}>
        <strong>
          At This Store
        </strong>
        {settings.avail_mens && (
          <p>
            Men&apos;s
          </p>
        )}
        {settings.avail_womens && (
          <p>
            Women&apos;s
          </p>
        )}
      </div>
      <div className={styles.directs}>
        <a 
          className={cta_link}
          href={`https://www.google.com/maps/dir/?api=1&destination=${gmaps_address}`}
          rel="noreferrer" 
          target="_blank"
        >
          Map
        </a>
        <img 
          className={styles.icon} 
          src={'https://cdn.shopify.com/s/files/1/0123/5065/2473/files/location.png?v=1625762676'} 
          loading="lazy" 
          width={100} height={100} 
          alt="" 
        />
      </div>
    </div>
  )
}

export default BlogStore

